import { useEffect } from "react";

const GithubCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (!code) {
      window.close();
      return;
    }

    // Send code to main window
    window.opener.postMessage(
      {
        type: "GITHUB_LOGIN_CODE",
        code
      },
      window.location.origin
    );

    window.close();
  }, []);

  return <p style={{ padding: 20 }}>Signing in with GitHub...</p>;
};

export default GithubCallback;
